import { render, staticRenderFns } from "./PriceGrossInput.vue?vue&type=template&id=dd164c60&"
import script from "./PriceGrossInput.vue?vue&type=script&lang=ts&"
export * from "./PriceGrossInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports